import classNames from 'classnames';
import styles from './input.module.scss';
import {forwardRef} from 'react';
import {PlatformIntl} from 'src/infra/PlatformIntl';

interface NumberInputProps {
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  name: string;
  // onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // onBlur: () => void;
  // ref
}

const intl = PlatformIntl.getInstance();

export const NumberInput = forwardRef(({
  placeholder = intl.formatMessage('sharedTypeHere'),
  className,
  ...rest
}: NumberInputProps, ref) => {
  return (
    <input
      // @ts-ignore
      ref={ref}
      type="number"
      className={classNames(styles.input, styles.numberInput, styles.border, styles.spacing, className)}
      placeholder={placeholder}
      {...rest}
    />
  );
});
